var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#04B900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8847 5.2068C11.0256 5.07269 11.213 4.99855 11.4075 5.00002C11.602 5.00149 11.7883 5.07846 11.9272 5.21469C12.066 5.35092 12.1464 5.53575 12.1516 5.73018C12.1567 5.92461 12.0861 6.11343 11.9547 6.2568L7.96471 11.2468C7.8961 11.3207 7.81329 11.38 7.72124 11.4212C7.62919 11.4623 7.52978 11.4845 7.42896 11.4864C7.32814 11.4882 7.22798 11.4698 7.13447 11.432C7.04095 11.3943 6.95601 11.3381 6.88471 11.2668L4.23871 8.6208C4.16502 8.55214 4.10592 8.46934 4.06493 8.37734C4.02394 8.28534 4.00189 8.18603 4.00012 8.08533C3.99834 7.98462 4.01686 7.88459 4.05459 7.79121C4.09231 7.69782 4.14845 7.61298 4.21967 7.54176C4.29089 7.47055 4.37572 7.4144 4.46911 7.37668C4.5625 7.33896 4.66253 7.32043 4.76323 7.32221C4.86393 7.32399 4.96325 7.34603 5.05525 7.38702C5.14725 7.42801 5.23005 7.48712 5.29871 7.5608L7.39271 9.6538L10.8657 5.2288C10.872 5.2211 10.8786 5.21376 10.8857 5.2068H10.8847Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDone);
export default __webpack_public_path__ + "static/media/icon_done.dd22b3f475553134cc45a636e1244963.svg";
export { ForwardRef as ReactComponent };